module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Medium.4a17e74.woff2";